module.exports = __webpack_public_path__ + "static/media/digitalvalley.01e32283.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/digitalvalley.webp
// module id = 783
// module chunks = 0